module.exports = __webpack_public_path__ + "img/wijk-bij-duurstede-logo.3efd52e9.png";